module.exports = __webpack_public_path__ + "static/media/defence.fcda52d6.png";